import React from 'react'
import style from './Smart.module.css'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ScrollArrow } from '../../../Components/ScrollArrow/ScrollArrow'

const Smart = () => {
  const { t } = useTranslation()
  return (
    <div className={style.smart} id={'smart'}>
      <div className={`${'customContainer'} ${style.smart_wrap}`}>
        <h2 className={style.title}>{t('smart.title')}</h2>
        <p className={style.desc}>{t('smart.desc')}</p>
        <Link to={'/smart-manufacturing'} className={style.button}>
          {t('smart.button')}
        </Link>
        <div className={style.block_arrow}>
          <ScrollArrow />
        </div>
      </div>
    </div>
  )
}

export default Smart
